import { useSelector } from 'store/store'
import { numberToDecimalString } from 'commons/utils/number'

import * as S from './styles'
import { Icon, StatisticsCard } from 'components'

export const Statistics = () => {
  const { negotiationsStatistics } = useSelector((state) => state.negotiations)

  const {
    VolumeEmPares,
    ValorTotal,
    ValorExcedente,
    VolumeEmParesDentroForaDeLinha: dadosVolume,
    ValorTotalDentroForaDeLinha: dadosValorTotal,
    ValorExcedenteDentroForaDeLinha: dadosValorExcedente
  } = negotiationsStatistics

  // TODO: Move to commons/utils/number or use formatToPTBRNumber?
  const formatCurrency = (value: number) =>
    new Intl.NumberFormat('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value)

  return (
    <S.StatisticsRow>
      <StatisticsCard
        icon={<Icon icon="sandal" color="#94A3BC" size="25" />}
        title="Volume em pares"
        mainValue={numberToDecimalString(VolumeEmPares)}
      >
        <>
          <S.Item>
            <strong>Em linha</strong>{' '}
            {numberToDecimalString(dadosVolume.PercentualEmLinha)}% •{' '}
            {numberToDecimalString(dadosVolume.EmLinha)}
          </S.Item>
          <S.Item>
            <strong>Fora de linha</strong>{' '}
            {numberToDecimalString(dadosVolume.PercentualForaDeLinha)}% •{' '}
            {numberToDecimalString(dadosVolume.ForaDeLinha)}
          </S.Item>
        </>
      </StatisticsCard>
      <StatisticsCard
        icon={<Icon icon="money" color="#94A3BC" size="25" />}
        title="Valor Total (R$)"
        mainValue={formatCurrency(ValorTotal)}
      >
        <>
          <S.Item>
            <strong>Em linha</strong>{' '}
            {numberToDecimalString(dadosValorTotal.PercentualEmLinha)}% •{' '}
            {formatCurrency(dadosValorTotal.EmLinha)}
          </S.Item>
          <S.Item>
            <strong>Fora de linha</strong>{' '}
            {numberToDecimalString(dadosValorTotal.PercentualForaDeLinha)}% •{' '}
            {formatCurrency(dadosValorTotal.ForaDeLinha)}
          </S.Item>
        </>
      </StatisticsCard>
      <StatisticsCard
        icon={<Icon icon="trending-up" color="#94A3BC" size="25" />}
        title="Excedente total (R$)"
        mainValue={formatCurrency(ValorExcedente)}
      >
        <>
          <S.Item>
            <strong>Em linha</strong>{' '}
            {numberToDecimalString(dadosValorExcedente.PercentualEmLinha)}% •{' '}
            {formatCurrency(dadosValorExcedente.EmLinha)}
          </S.Item>
          <S.Item>
            <strong>Fora de linha</strong>{' '}
            {numberToDecimalString(dadosValorExcedente.PercentualForaDeLinha)}% •{' '}
            {formatCurrency(dadosValorExcedente.ForaDeLinha)}
          </S.Item>
        </>
      </StatisticsCard>
    </S.StatisticsRow>
  )
}
